<!-- Charge Types Tab Content -->
<div class="charge-types-tab-content">
  <!-- Title and Add Button -->
  <div class="mb-3">
    <div class="d-flex justify-content-between align-items-start mb-2">
      <div>
        <h5 class="mb-1">Carrier Charge Types</h5>
        <p class="text-muted small mb-0">Manage flexible charge types used across shipments</p>
      </div>
      <button class="btn btn-primary" (click)="openAddModal()">
        <i class="bi bi-plus-circle me-1"></i>Add Charge Type
      </button>
    </div>
  </div>

  <!-- Search and Filter Bar -->
  <div class="row mb-3">
    <div class="col-md-6">
      <input
        type="text"
        class="form-control"
        placeholder="Search charge types..."
        [(ngModel)]="searchTerm"
        (input)="applyFilters()"
      />
    </div>
    <div class="col-md-6 text-end">
      <div class="btn-group" role="group">
        <button
          type="button"
          class="btn btn-sm"
          [class.btn-primary]="selectedModeFilter === 'ALL'"
          [class.btn-outline-primary]="selectedModeFilter !== 'ALL'"
          (click)="filterByMode('ALL')">
          ALL
        </button>
        <button
          type="button"
          class="btn btn-sm"
          [class.btn-primary]="selectedModeFilter === 'SEA'"
          [class.btn-outline-primary]="selectedModeFilter !== 'SEA'"
          (click)="filterByMode('SEA')">
          SEA
        </button>
        <button
          type="button"
          class="btn btn-sm"
          [class.btn-primary]="selectedModeFilter === 'AIR'"
          [class.btn-outline-primary]="selectedModeFilter !== 'AIR'"
          (click)="filterByMode('AIR')">
          AIR
        </button>
      </div>
    </div>
  </div>

  <!-- Charge Types Table -->
  <div class="table-responsive">
    <table class="table table-hover align-middle">
      <thead>
        <tr>
          <th>Charge Name</th>
          <th>Mode</th>
          <th>Applies To</th>
          <th>Charge Basis</th>
          <th>Remarks</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let type of filteredChargeTypes">
          <td><strong>{{ type.name }}</strong></td>
          <td>
            <span class="badge" [class.bg-warning]="type.mode === 'AIR'" [class.bg-primary]="type.mode === 'SEA'">
              {{ type.mode }}
            </span>
          </td>
          <td>
            <span *ngFor="let applies of type.appliesTo" class="badge bg-light text-dark me-1">{{ applies }}</span>
          </td>
          <td>{{ type.chargeBasis }}</td>
          <td class="text-muted small">{{ type.remarks }}</td>
          <td>
            <button class="btn btn-sm btn-link p-1" title="Edit" (click)="editChargeType(type)">
              <i class="bi bi-pencil"></i>
            </button>
            <button class="btn btn-sm btn-link text-danger p-1" title="Delete" (click)="deleteChargeType(type)">
              <i class="bi bi-trash"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="filteredChargeTypes.length === 0">
          <td colspan="6" class="text-center text-muted py-4">
            <i class="bi bi-inbox me-2"></i>No charge types found
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Add/Edit Charge Type Modal -->
<div class="modal-backdrop fade show" *ngIf="showAddModal" style="z-index: 2000;"></div>
<div class="modal fade show d-block" *ngIf="showAddModal" tabindex="-1" role="dialog" style="z-index: 2001;">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ isEditMode ? 'Edit' : 'Create' }} Charge Type</h5>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <form>
          <!-- Charge Name -->
          <div class="mb-3">
            <label class="form-label">Charge Name <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="formData.name"
              name="chargeName"
              placeholder="e.g. Ocean Freight, BAF, Documentation Fee"
              required
            />
          </div>

          <!-- Mode -->
          <div class="mb-3">
            <label class="form-label">Mode <span class="text-danger">*</span></label>
            <select class="form-select" [(ngModel)]="formData.mode" name="mode" required>
              <option value="" disabled>Select mode</option>
              <option value="SEA">SEA</option>
              <option value="AIR">AIR</option>
            </select>
          </div>

          <!-- Charge Basis -->
          <div class="mb-3">
            <label class="form-label">Charge Basis</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="formData.chargeBasis"
              name="chargeBasis"
              placeholder="e.g. per container, per cbm, per kg"
            />
          </div>

          <!-- Remarks -->
          <div class="mb-3">
            <label class="form-label">Remarks</label>
            <textarea
              class="form-control"
              rows="3"
              [(ngModel)]="formData.remarks"
              name="remarks"
              placeholder="Optional description or notes"
            ></textarea>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="saveChargeType()">
          {{ isEditMode ? 'Update' : 'Create' }}
        </button>
      </div>
    </div>
  </div>
</div>
